import { render, staticRenderFns } from "./Step4Characteristics.vue?vue&type=template&id=4fa234b1&scoped=true"
import script from "./Step4Characteristics.vue?vue&type=script&lang=js"
export * from "./Step4Characteristics.vue?vue&type=script&lang=js"
import style0 from "./Step4Characteristics.vue?vue&type=style&index=0&id=4fa234b1&prod&lang=css"
import style1 from "./Step4Characteristics.vue?vue&type=style&index=1&id=4fa234b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa234b1",
  null
  
)

export default component.exports